module.exports = {
  //outputDir: '../wwwroot',
  //publicPath: '/eservices/',
  //publicPath: '././',
  publicPath: process.env.NODE_ENV === 'production' ? '././' : '',
  configureWebpack: {
    devtool: 'source-map'
  },
  transpileDependencies: ['vuetify'],
  devServer: {
    progress: !!process.env.VUE_DEV_SERVER_PROGRESS
  }
}
